/* ============================================
   SMITH'S BLADES — BLOG LISTING JS
   v1.0 | Cronix Solutions
   ============================================ */

(function () {
  'use strict';

  /* ——————————————————————————————————————
     1. SCROLL REVEAL
     —————————————————————————————————————— */
  var blogRevealEls = document.querySelectorAll('.blog-reveal');
  if (blogRevealEls.length > 0) {
    var blogObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('blog-visible');
          blogObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    blogRevealEls.forEach(function (el) {
      blogObserver.observe(el);
    });
  }

  /* ——————————————————————————————————————
     2. TAG FILTER
     —————————————————————————————————————— */
  var filterBtns = document.querySelectorAll('.blog-filter-btn');
  var gridItems = document.querySelectorAll('.blog-grid-item');

  if (filterBtns.length > 0) {
    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var selectedTag = this.getAttribute('data-tag');

        // Update active state
        filterBtns.forEach(function (b) { b.classList.remove('active'); });
        this.classList.add('active');

        // Filter items
        gridItems.forEach(function (item) {
          var itemTags = item.getAttribute('data-tags');

          if (selectedTag === 'all' || itemTags.includes(selectedTag)) {
            item.classList.remove('hidden');
          } else {
            item.classList.add('hidden');
          }
        });
      });
    });
  }

  /* ——————————————————————————————————————
     3. LOAD MORE (AJAX Pagination)
     —————————————————————————————————————— */
  var loadMoreBtn = document.getElementById('blogLoadMore');
  var blogGrid = document.getElementById('blogGrid');

  if (loadMoreBtn && blogGrid) {
    loadMoreBtn.addEventListener('click', function () {
      var nextUrl = this.getAttribute('data-next-url');
      if (!nextUrl) return;

      // Show loading state
      loadMoreBtn.classList.add('loading');
      loadMoreBtn.disabled = true;

      // Fetch next page
      fetch(nextUrl)
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newItems = doc.querySelectorAll('.blog-grid-item');
          var newLoadMoreBtn = doc.getElementById('blogLoadMore');

          // Append new items
          newItems.forEach(function (item) {
            blogGrid.appendChild(item);
          });

          // Update or remove load more button
          if (newLoadMoreBtn) {
            var newNextUrl = newLoadMoreBtn.getAttribute('data-next-url');
            loadMoreBtn.setAttribute('data-next-url', newNextUrl);
            loadMoreBtn.classList.remove('loading');
            loadMoreBtn.disabled = false;

            // Update pagination info
            var newPaginationInfo = doc.querySelector('.blog-pagination-info');
            if (newPaginationInfo) {
              document.querySelector('.blog-pagination-info').textContent = newPaginationInfo.textContent;
            }
          } else {
            // No more pages
            loadMoreBtn.style.display = 'none';
            var paginationInfo = document.querySelector('.blog-pagination-info');
            if (paginationInfo) {
              paginationInfo.textContent = 'All articles loaded';
            }
          }

          // Re-observe new items for scroll reveal
          if (blogObserver) {
            newItems.forEach(function (el) {
              blogObserver.observe(el);
            });
          }
        })
        .catch(function (error) {
          console.error('Load more error:', error);
          loadMoreBtn.classList.remove('loading');
          loadMoreBtn.disabled = false;
          alert('Failed to load more articles. Please try again.');
        });
    });
  }

})();